/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OAuth2Error = {
  /**
   * OAuth2 error code
   */
  error: OAuth2Error.error;
  /**
   * Human-readable error description
   */
  error_description?: string | null;
  /**
   * URI for additional error information
   */
  error_uri?: string | null;
};
export namespace OAuth2Error {
  /**
   * OAuth2 error code
   */
  export enum error {
    INVALID_REQUEST = 'invalid_request',
    INVALID_CLIENT = 'invalid_client',
    INVALID_GRANT = 'invalid_grant',
    UNAUTHORIZED_CLIENT = 'unauthorized_client',
    UNSUPPORTED_GRANT_TYPE = 'unsupported_grant_type',
    INVALID_SCOPE = 'invalid_scope',
    INVALID_TOKEN = 'invalid_token',
    INSUFFICIENT_SCOPE = 'insufficient_scope',
  }
}
